import { BehaviorSubject } from 'rxjs';

export const openedModal$ = new BehaviorSubject('');

export const getOpenedModal$ = () => openedModal$;

export const setOpenedModal$ = (openedModal: string) =>
  openedModal$.next(openedModal);
